import "./styles/pricing/app.scss";

// start the Stimulus application
import "./bootstrap";

// this "modifies" the jquery module: adding behavior to it
// the bootstrap module doesn't export/return anything
window.bootstrap = require("bootstrap");
const popoverTriggerList = [].slice.call(
  document.querySelectorAll('[data-bs-toggle="popover"]')
);
popoverTriggerList.map(function (el) {
  return new bootstrap.Popover(el);
});
